import { Navigate, Outlet, Route, useLocation } from "react-router-dom";
import PartnerLoginPage from "../../../pages/partner/PartnerLoginPage";
import PartnerPortalDashboardPage from "../../../pages/partner/PartnerPortalDashboardPage";
import PartnerLeadsPage from "../../../pages/partner/PartnerLeadsPage";
import PartnerProfilePage from "../../../pages/partner/PartnerProfilePage";
import PartnerSponsorshipAssetsPage from "../../../pages/partner/PartnerSponsorshipAssetsPage";
import AutoMapaSponsorshipPlacementsPage from "../../../pages/automapa/admin/AutoMapaSponsorshipPlacementsPage";
import AutoMapaCampaignsPage from "../../../pages/automapa/admin/AutoMapaCampaignsPage";
import AutoMapaAnalyticsLayout from "../../../pages/automapa/admin/AutoMapaAnalyticsLayout";
import AutoMapaAccessIamPage from "../../../pages/automapa/admin/AutoMapaAccessIamPage";
import CasaMapaAdminWebsiteAnalyticsPage from "../../../pages/casamapa/admin/CasaMapaAdminWebsiteAnalyticsPage";
import CasaMapaAdminMarketAnalysisPage from "../../../pages/casamapa/admin/CasaMapaAdminMarketAnalysisPage";
import CasaMapaAdminPropertyValuationPage from "../../../pages/casamapa/admin/CasaMapaAdminPropertyValuationPage";
import CasaMapaAdminInvestmentAnalysisPage from "../../../pages/casamapa/admin/CasaMapaAdminInvestmentAnalysisPage";
import PartnerSourcesPage from "../../../pages/partner/PartnerSourcesPage";
import PartnerDealersPage from "../../../pages/partner/PartnerDealersPage";
import PartnerDealerAccountProfilePage from "../../../pages/partner/PartnerDealerAccountProfilePage";
import PartnerDealerDetailPage from "../../../pages/partner/PartnerDealerDetailPage";
import PartnerDealerInventoryPage from "../../../pages/partner/PartnerDealerInventoryPage";
import PartnerDealerListingFormPage from "../../../pages/partner/PartnerDealerListingFormPage";
import PartnerDealerVehicleNamesPage from "../../../pages/partner/PartnerDealerVehicleNamesPage";
import PartnerInventoryHealthPage from "../../../pages/partner/PartnerInventoryHealthPage";
import PartnerInventoryNormalizationReviewPage from "../../../pages/partner/PartnerInventoryNormalizationReviewPage";
import PartnerWhatsappMonitoringPage from "../../../pages/partner/PartnerWhatsappMonitoringPage";
import PartnerWhatsappConversationsPage from "../../../pages/partner/PartnerWhatsappConversationsPage";
import PartnerWhatsappConversationDetailPage from "../../../pages/partner/PartnerWhatsappConversationDetailPage";
import PartnerWhatsappDealerHealthPage from "../../../pages/partner/PartnerWhatsappDealerHealthPage";
import PartnerWhatsappFeatureGate from "../../partner/PartnerWhatsappFeatureGate";
import PartnerDealerWorkspace from "../../partner/PartnerDealerWorkspace";
import { PartnerPortalBaseProvider } from "../../partner/PartnerPortalBaseProvider";
import AutoMapaAdminPortalLayout from "./AutoMapaAdminPortalLayout";
import { AUTOMAP_CLIENT_VIEW_SLUG } from "../../../constants/automapPartnerPortalConfig";
import { automapAdminPortalPath } from "../../../constants/automapAdminPortalPaths";
import { AUTOMAP_PARTNER_PORTAL_I18N_MANIFEST } from "../../../constants/automapPartnerPortalI18n";
import { IntlProvider } from "../../../intl";

function AutoMapaAdminPortalShell() {
  return (
    <IntlProvider surface="clientView" manifest={AUTOMAP_PARTNER_PORTAL_I18N_MANIFEST}>
      <PartnerPortalBaseProvider clientViewSlug={AUTOMAP_CLIENT_VIEW_SLUG}>
        <Outlet />
      </PartnerPortalBaseProvider>
    </IntlProvider>
  );
}

/** Legacy /v/automap/partner/* URLs redirect to the admin console. */
export function AutoMapaPartnerLegacyRedirect() {
  const location = useLocation();
  const suffix = location.pathname.replace(/^\/v\/automap\/partner\/?/, "");
  const target = suffix
    ? `${automapAdminPortalPath(suffix)}${location.search}${location.hash}`
    : `${automapAdminPortalPath("dashboard")}${location.search}${location.hash}`;
  return <Navigate to={target} replace />;
}

export function automapAdminPortalChildRoutes() {
  return (
    <>
      <Route path="dashboard" element={<PartnerPortalDashboardPage />} />
      <Route path="inventory-health" element={<PartnerInventoryHealthPage />} />
      <Route
        path="inventory-health/normalization"
        element={<PartnerInventoryNormalizationReviewPage />}
      />
      <Route
        path="whatsapp"
        element={
          <PartnerWhatsappFeatureGate>
            <PartnerWhatsappMonitoringPage />
          </PartnerWhatsappFeatureGate>
        }
      />
      <Route
        path="whatsapp/conversations"
        element={
          <PartnerWhatsappFeatureGate>
            <PartnerWhatsappConversationsPage />
          </PartnerWhatsappFeatureGate>
        }
      />
      <Route
        path="whatsapp/conversations/:crmLeadId"
        element={
          <PartnerWhatsappFeatureGate>
            <PartnerWhatsappConversationDetailPage />
          </PartnerWhatsappFeatureGate>
        }
      />
      <Route
        path="whatsapp/dealers"
        element={
          <PartnerWhatsappFeatureGate>
            <PartnerWhatsappDealerHealthPage />
          </PartnerWhatsappFeatureGate>
        }
      />
      <Route path="dealers" element={<PartnerDealersPage />} />
      <Route path="dealers/:dealerId" element={<PartnerDealerAccountProfilePage />} />
      <Route path="dealers/:dealerId/inventory" element={<PartnerDealerWorkspace />}>
        <Route index element={<PartnerDealerInventoryPage />} />
        <Route path="normalization" element={<PartnerDealerVehicleNamesPage />} />
        <Route path="new" element={<PartnerDealerListingFormPage />} />
        <Route path=":listingId/edit" element={<PartnerDealerListingFormPage />} />
      </Route>
      <Route path="dealers/:dealerId/account" element={<PartnerDealerDetailPage />} />
      <Route path="leads" element={<PartnerLeadsPage />} />
      <Route path="analytics" element={<AutoMapaAnalyticsLayout />}>
        <Route index element={<Navigate to="website" replace />} />
        <Route path="website" element={<CasaMapaAdminWebsiteAnalyticsPage />} />
        <Route path="market" element={<CasaMapaAdminMarketAnalysisPage />} />
        <Route path="valuation" element={<CasaMapaAdminPropertyValuationPage />} />
        <Route path="investment" element={<CasaMapaAdminInvestmentAnalysisPage />} />
      </Route>
      <Route path="access-iam" element={<AutoMapaAccessIamPage />} />
      <Route path="profile" element={<PartnerProfilePage />} />
      <Route path="sponsorship-assets" element={<PartnerSponsorshipAssetsPage />} />
      <Route path="sponsorship-placements" element={<AutoMapaSponsorshipPlacementsPage />} />
      <Route path="campaigns" element={<AutoMapaCampaignsPage />} />
      <Route path="sources" element={<PartnerSourcesPage />} />
    </>
  );
}

export function AutoMapaAdminPortalRouteGroup() {
  return (
    <>
      <Route path="/v/automap/partner/*" element={<AutoMapaPartnerLegacyRedirect />} />
      <Route path="/v/automap/admin" element={<AutoMapaAdminPortalShell />}>
        <Route path="login" element={<PartnerLoginPage />} />
        <Route index element={<Navigate to={automapAdminPortalPath("dashboard")} replace />} />
        <Route element={<AutoMapaAdminPortalLayout />}>
          {automapAdminPortalChildRoutes()}
        </Route>
      </Route>
    </>
  );
}
